import { sortBy , uniqBy } from 'lodash-es';

import type { ControlVersionDto } from '@src/api';
import type {
  ControlVersionDtoDefId,
} from '@stores/dictionaryStores/controlVersionsStore/controlVersionsStore';

type ControlDtoWithChildren = ControlVersionDto & {
  children?: ControlDtoWithChildren[];
  key: string;
  title: string;
};

export const toTreeView = (controlVersions: ControlVersionDtoDefId[]): ControlDtoWithChildren[] => {
  const output = sortBy(
    controlVersions.filter((version) => version.repGroupCode && version.ctrlCode),
    ['repGroupCode', 'ctrlGroupOrder', 'ctrlCode'],
  );

  return uniqBy(output, 'repGroupCode').map((item) => ({
    repGroupCode: item.repGroupCode,
    key: item.repGroupCode ?? '',
    title: `${item.repGroupCode} - ${item.repGroupName}`,
    children: uniqBy(
      output.filter((el) => el.repGroupCode === item.repGroupCode),
      'ctrlGroupCode',
    ).map((group) => {
      const uniqByCtrlCode = uniqBy(
        output.filter((el) => el.repGroupCode === item.repGroupCode && el.ctrlGroupCode === group.ctrlGroupCode),
        'ctrlCode',
      );

      return {
        repGroupCode: group.repGroupCode,
        ctrlGroupCode: group.ctrlGroupCode,
        key: `${item.repGroupCode} - ${group.ctrlGroupCode}`,
        title: `${group.ctrlGroupCode} - ${group.ctrlGroupName}`,
        count: output.filter(
          (version) => version.repGroupCode === group.repGroupCode && version.ctrlGroupCode === group.ctrlGroupCode,
        ).length,
        children: uniqByCtrlCode.map((el) => ({
          ...el,
          key: `${el.repGroupCode} - ${el.ctrlCode}`,
          title: `${el.ctrlCode} - ${el.ctrlVersExt} - ${el.ctrlName}`,
          count: output.filter(
            (version) =>
              version.repGroupCode === el.repGroupCode &&
              version.ctrlGroupCode === el.ctrlGroupCode &&
              version.ctrlCode === el.ctrlCode,
          ).length,
        })),
      };
    }),
  }));
};
